export interface LegalDocumentsCountries {
  Country: string
  Privacy_Policy: string
  Terms_Conditions: string
  Country_Code: string
}

/**
 * This file contains the legal documents URLs for different countries.
 * It is used to provide the correct links for privacy policies and terms & conditions
 * https://umdasch.sharepoint.com/sites/ts000218/Lists/Legal%20Package%20Digital%20Solutions%20%20country%20implement/AllItems.aspx
 */
export const LEGAL_DOCUMENTS_COUNTRIES_JSON = [
  {
    Country: 'Doka GmbH',
    Privacy_Policy: 'https://www.doka.com/en/home/dataprivacy/index',
    Terms_Conditions: 'https://www.doka.com/en/home/termsandconditions/AGB',
    Country_Code: 'DEFAULT',
  },
  {
    Country: 'Doka Austria (DAUT)',
    Privacy_Policy: 'https://www.doka.com/at/home/dataprivacy/index',
    Terms_Conditions: 'https://www.doka.com/at/home/termsandconditions/index',
    Country_Code: 'AT',
  },
  {
    Country: 'Doka Germany (DDEU)',
    Privacy_Policy: 'https://www.doka.com/de/home/dataprivacy/index',
    Terms_Conditions: 'https://www.doka.com/de/home/termsandconditions/AGB',
    Country_Code: 'DE',
  },
  {
    Country: 'Doka Australia (DAUS)',
    Privacy_Policy: '',
    Terms_Conditions: 'https://www.doka.com/au/home/termsandconditions/AGB?changecountry=AU',
    Country_Code: 'AU',
  },
  {
    Country: 'Doka Slipform (DSF)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: '',
  },
  {
    Country: 'Doka Switzerland (DCHE)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'CH',
  },
  {
    Country: 'Doka USA (DUSA)',
    Privacy_Policy: 'https://www.doka.com/us/home/dataprivacy/index?changecountry=US',
    Terms_Conditions: 'https://www.doka.com/us/home/termsandconditions/AGB',
    Country_Code: 'US',
  },
  {
    Country: 'Doka Great Britain (DGBR)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'GB',
  },
  {
    Country: 'Doka Ireland (DIRL)',
    Privacy_Policy: 'https://www.doka.com/en/home/dataprivacy/index?changecountry=IE',
    Terms_Conditions: 'https://www.doka.com/en/home/termsandconditions/AGB',
    Country_Code: 'IE',
  },
  {
    Country: 'Doka Denmark (DDNK)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'DK',
  },
  {
    Country: 'Doka Croatia (DHRV)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'HR',
  },
  {
    Country: 'Doka France (DFRA)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'FR',
  },
  {
    Country: 'Doka Slovenia (DSVN)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'SI',
  },
  {
    Country: 'Doka Belgium (DBEL)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'BE',
  },
  {
    Country: 'Doka Estonia (DEST)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'EE',
  },
  {
    Country: 'Doka Canada (DCAN)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'CA',
  },
  {
    Country: 'Doka Latvia (DLVA)',
    Privacy_Policy: 'https://www.doka.com/lv/home/dataprivacy/index',
    Terms_Conditions:
      'https://www.doka.com/lv/home/termsandconditions/noteikumi-un-nosacijumi?changecountry=LV',
    Country_Code: 'LV',
  },
  {
    Country: 'Doka Lithuania (DLTU)',
    Privacy_Policy: 'https://www.doka.com/lt/home/dataprivacy/index?changecountry=LT',
    Terms_Conditions: 'https://www.doka.com/lt/home/termsandconditions/salygos',
    Country_Code: 'LT',
  },
  {
    Country: 'Doka Norway (DNOR)',
    Privacy_Policy: 'https://www.doka.com/no/home/dataprivacy/index',
    Terms_Conditions:
      'https://www.doka.com/no/home/termsandconditions/terms-and-conditions?changecountry=NO',
    Country_Code: 'NO',
  },
  {
    Country: 'Doka Belarus',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'BY',
  },
  {
    Country: 'Doka Sweden (DSWE)',
    Privacy_Policy: 'https://www.doka.com/se/home/dataprivacy/index?changecountry=SE',
    Terms_Conditions: 'https://www.doka.com/se/home/termsandconditions/AGB',
    Country_Code: 'SE',
  },
  {
    Country: 'Doka Czech Republic (DCZE)',
    Privacy_Policy: 'https://www.doka.com/cz/home/dataprivacy/index',
    Terms_Conditions: 'https://www.doka.com/cz/home/termsandconditions/VODP',
    Country_Code: 'CZ',
  },
  {
    Country: 'Doka Hungary (DHUN)',
    Privacy_Policy: 'https://www.doka.com/hu/home/dataprivacy/index',
    Terms_Conditions: 'https://www.doka.com/hu/home/termsandconditions/AGB',
    Country_Code: 'HU',
  },
  {
    Country: 'Doka Peru (DPER)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'PE',
  },
  {
    Country: 'Doka Slovakia (DSVK)',
    Privacy_Policy: 'https://www.doka.com/sk/home/dataprivacy/index',
    Terms_Conditions: '/sites/ts000170/Lists/STI/DispForm.aspx?ID=102&e=1qldcw',
    Country_Code: 'SK',
  },
  {
    Country: 'Doka Ukraine (DUKR)',
    Privacy_Policy: '',
    Terms_Conditions:
      'https://www.doka.com/ua/home/termsandconditions/terms-and-conditions?changecountry=UA',
    Country_Code: 'UA',
  },
  {
    Country: 'Doka Hellas (DGRC)',
    Privacy_Policy: 'https://www.doka.com/en/home/dataprivacy/index',
    Terms_Conditions: 'https://www.doka.com/en/home/termsandconditions/AGB',
    Country_Code: 'GR',
  },
  {
    Country: 'Doka Spain (DESP)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'ES',
  },
  {
    Country: 'Doka Poland (DPOL)',
    Privacy_Policy: '',
    Terms_Conditions: 'https://www.doka.com/pl/home/termsandconditions/AGB',
    Country_Code: 'PL',
  },
  {
    Country: 'Doka Netherlands (DNED)',
    Privacy_Policy: 'https://www.doka.com/nl/home/dataprivacy/index?changecountry=NL',
    Terms_Conditions: 'https://www.doka.com/nl/home/termsandconditions/AGB',
    Country_Code: 'NL',
  },
  {
    Country: 'Doka Romania (DROU)',
    Privacy_Policy: 'https://www.doka.com/ro/home/dataprivacy/index',
    Terms_Conditions:
      'https://www.doka.com/ro/home/termsandconditions/Conditii-contractuale-Generale',
    Country_Code: 'RO',
  },
  {
    Country: 'Doka Bulgaria (DBGR)',
    Privacy_Policy: 'https://www.doka.com/dokagroup/doka-bulgaria.bg.php',
    Terms_Conditions: 'https://www.doka.com/dokagroup/doka-bulgaria.bg.php',
    Country_Code: 'BG',
  },
  {
    Country: 'Doka Finland (DFIN)',
    Privacy_Policy: 'https://www.doka.com/fi/home/dataprivacy/index',
    Terms_Conditions: 'https://www.doka.com/fi/home/termsandconditions/AGB?changecountry=FI',
    Country_Code: 'FI',
  },
  {
    Country: 'Doka Israel (DISR)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'IL',
  },
  {
    Country: 'Doka Italy (DITA)',
    Privacy_Policy: 'https://www.doka.com/it/home/dataprivacy/index?changecountry=IT',
    Terms_Conditions: 'https://www.doka.com/it/home/termsandconditions/AGB',
    Country_Code: 'IT',
  },
  {
    Country: 'Doka Serbia (DSRB)',
    Privacy_Policy: 'https://www.doka.com/rs/home/termsandconditions/AGB',
    Terms_Conditions: 'https://www.doka.com/rs/home/termsandconditions/AGB',
    Country_Code: 'RS',
  },
  {
    Country: 'Doka Indonesia (DIDN)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'ID',
  },
  {
    Country: 'Doka India (DIND)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'IN',
  },
  {
    Country: 'Doka Malaysia (DMYS)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'MY',
  },
  {
    Country: 'Doka Philippines (DPHL)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'PH',
  },
  {
    Country: 'Lubeca Australia (LAUS)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'AU',
  },
  {
    Country: 'Doka Singapore (DSGP)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'SG',
  },
  {
    Country: 'Doka Egypt (DEGY)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'EG',
  },
  {
    Country: 'Doka Oman (DOMN)',
    Privacy_Policy: 'https://www.doka.com/me/home/dataprivacy/index?changecountry=OM',
    Terms_Conditions: 'https://www.doka.com/me/home/termsandconditions/AGB?changecountry=AE',
    Country_Code: 'OM',
  },
  {
    Country: 'Doka Gulf (DARE)',
    Privacy_Policy: 'https://www.doka.com/me/home/dataprivacy/index?changecountry=AE',
    Terms_Conditions: 'https://www.doka.com/me/home/termsandconditions/AGB?changecountry=AE',
    Country_Code: 'AE',
  },
  {
    Country: 'Doka Kuwait incl. Jordan (DKWT)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'KW',
  },
  {
    Country: 'Doka Mozambique (DMOZ)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'MZ',
  },
  {
    Country: 'Doka Qatar (DQAT)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'QA',
  },
  {
    Country: 'Doka Türkiye (DTUR)',
    Privacy_Policy: 'https://www.doka.com/tr/home/dataprivacy/index',
    Terms_Conditions: '',
    Country_Code: 'TR',
  },
  {
    Country: 'Doka Mexico (DMEX)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'MX',
  },
  {
    Country: 'Doka South Africa (DZAE)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'ZA',
  },
  {
    Country: 'Doka Chile (DCHL)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'CL',
  },
  {
    Country: 'Doka Panama / Doka Colombia (DPANDCOL)',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'PA',
  },
  {
    Country: 'Doka Saudi Arabia',
    Privacy_Policy: '',
    Terms_Conditions: '',
    Country_Code: 'SA',
  },
]
